import React from 'react';
import PropTypes from 'prop-types';

import ReviewEntry from '../ReviewEntry';

function FeedbackEntryComponent({ feedback }) {
  return (
    <ReviewEntry
      username={feedback.author}
      rate={feedback.rate}
      message={feedback.data}
      state={feedback.state}
      title={feedback.title}
      date={feedback.addedDate}
      country={feedback.authorCountryCode}
    />
  );
}

FeedbackEntryComponent.propTypes = {
  feedback: PropTypes.object.isRequired,
};

export default FeedbackEntryComponent;
